import { loader } from 'graphql.macro';

export const ACTIVE_ANNOUNCEMENTS_LIST = loader(
  './activeAnnouncementsListQuery.graphql',
);
export const ARCHIVED_DEPOSIT_REWARD_HISTORY = loader(
  './archivedDepositRewardHistoryQuery.graphql',
);
export const ARCHIVED_MERCHANT_REFERRAL_REWARD_HISTORY = loader(
  './archivedMerchantReferralRewardHistoryQuery.graphql',
);
export const ARCHIVED_SELF_CONSUMPTION_REWARD_HISTORY = loader(
  './archivedSelfConsumptionRewardHistoryQuery.graphql',
);
export const ARCHIVED_GROWTH_REWARD_HISTORY = loader(
  './archivedGrowthRewardHistoryQuery.graphql',
);
export const ARCHIVED_TEAM_CONSUMPTION_REWARD_HISTORY = loader(
  './archivedTeamConsumptionRewardHistoryQuery.graphql',
);
export const ARCHIVED_CITIZEN_REFERRAL_COMMISSIONS_HISTORY = loader(
  './archivedCitizenReferralCommissionsHistoryQuery.gql',
);
export const ARCHIVED_SUPER_ORDER_COMMISSION_HISTORY = loader(
  './archivedSuperOrderCommissionHistory.graphql',
);
export const ARCHIVED_SUPER_ORDER_PASSIVE_INCOME = loader(
  './archivedSuperOrderPassiveIncome.graphql',
);
export const ARTICLE = loader('./articleQuery.graphql');
export const ARTICLES_LIST = loader('./articlesListQuery.graphql');
export const CITIZEN_LIST = loader('./citizenListQuery.graphql');
export const CITIZEN_REFERRAL_REWARD_HISTORY = loader(
  './citizenReferralRewardHistoryQuery.graphql',
);
export const CONSUMPTION_PLATFORMS_LIST = loader(
  './consumptionPlatformsListQuery.graphql',
);
export const PLATFORM_TYPE_LIST = loader('./platformTypeListQuery.graphql');
export const TRANSACTION_TYPE_LIST = loader(
  './transactionTypeListQuery.graphql',
);
export const TRANSACTION_FLOW_TYPE_LIST = loader(
  './transactionFlowTypeListQuery.graphql',
);
export const DEPOSIT_INFO = loader('./depositInfoQuery.graphql');
export const DEPOSIT_HISTORY = loader('./depositHistoryQuery.graphql');
export const DEPOSIT_PLANS_LIST = loader('./depositPlansListQuery.graphql');
export const VOUCHER_SALES_HISTORY = loader(
  './voucherSalesHistoryQuery.graphql',
);
export const DRAFT = loader('./draftQuery.graphql');
export const ELEVATE_TOKENS = loader('./elevateTokensQuery.graphql');
export const GENERATIONS_LIST = loader('./generationsListQuery.graphql');
export const LOAN_HISTORY = loader('./loanHistoryQuery.graphql');
export const VOUCHER_SALES_TYPE_LIST = loader(
  './voucherSalesTypeListQuery.graphql',
);
export const INTERNAL_TRX_LIST = loader(
  './internalTransactionsListQuery.graphql',
);
export const INTERNAL_TRX_TYPE_LIST = loader(
  './internalTransactionTypeListQuery.graphql',
);
export const INTERNAL_TRX_STATUS_TYPE_LIST = loader(
  './internalTransactionStatusTypeListQuery.graphql',
);
export const INTERNAL_TRX_FEE = loader('./internalTransactionFeeQuery.graphql');
export const LOAN_PLAN_LIST = loader('./loanPlanListQuery.graphql');
export const LOGGED_IN_USER = loader('./loggedInUserQuery.graphql');
export const MERCHANT_REFERRAL_REWARD_HISTORY = loader(
  './merchantReferralRewardHistoryQuery.graphql',
);
export const MEGOPOLY_REWARD_HISTORY = loader(
  './megopolyRewardHistoryQuery.graphql',
);
export const MEGOPOLY_OPEN_MARKET_HISTORY = loader(
  './megopolyOpenMarketHistoryQuery.graphql',
);
export const MY_WALLET = loader('./myWalletQuery.graphql');
export const NETWORK_BREADCRUMBS = loader('./networkBreadcrumbsQuery.graphql');
export const NETWORK_CITY_DETAILS = loader('./networkCityDetailsQuery.graphql');
export const NETWORK_GENERATION_COUNT_REFERRAL = loader(
  './networkGenerationCountReferralQuery.graphql',
);
export const NETWORK_REFERRALS = loader('./networkReferralsQuery.graphql');
export const NETWORK_SEARCH_PARAMETERS = loader(
  './networkSearchParametersQuery.graphql',
);
export const NETWORK_USER_PROFILE = loader('./networkUserProfileQuery.graphql');
export const NOTIFICATIONS_LIST = loader('./notificationsListQuery.graphql');
export const REFERRAL_LINK = loader('./referralLinkQuery.graphql');
export const RETAIL_INCOME_HISTORY = loader(
  './retailIncomeHistoryQuery.graphql',
);
export const SCORE_TABLE_LIST = loader('./scoreTableListQuery.graphql');
export const SELF_CONSUMPTION_REWARD_HISTORY = loader(
  './selfConsumptionRewardHistoryQuery.graphql',
);
export const SETTINGS = loader('./settingsQuery.graphql');
export const SUPER_ORDER_COMMISSIONS_HISTORY = loader(
  './superOrderCommissionsHistoryQuery.graphql',
);
export const TOP_UP_LIST = loader('./topUpListQuery.graphql');
export const TUTORIAL_VIDEOS_GROUPS_LIST = loader(
  './tutorialVideosGroupsListQuery.graphql',
);
export const USE_INCOME_HISTORY = loader('./useIncomeHistoryQuery.graphql');
export const OTHER_PLATFORMS_TRX_LIST = loader(
  './otherPlatformsTrxListQuery.graphql',
);
export const VIEWER = loader('./viewerQuery.graphql');
export const WITHDRAWAL_LIST = loader('./withdrawalListQuery.graphql');
export const WITHDRAWAL_TRANSACTION_FEE = loader(
  './withdrawalTransactionFeeQuery.graphql',
);
export const WITHDRAWAL_TRANSFER = loader('./withdrawalTransferQuery.graphql');
